export enum FraudCaseReportEnum {
  Excel = 'excel',
  PDF = 'pdf',
}
